import { TGraphItems } from "modules/types/advanced_stats";
import React from "react";
import { HubStatsTitle, HubStatsWrapper, GraphWrapper, GraphTitleValue } from "apps/BWW_PLAY_HUB/components/HubStats/styles";
import {
	HubStatsLegend
} from "apps/BWW_PLAY_HUB/components/HubStats/HubStatsLegend";
import {
	HubStatsDaysGraph
} from "apps/BWW_PLAY_HUB/components/HubStats/HubStatsDaysGraph";
import { EnumStatsType, getPercent } from "apps/BWW_PLAY_HUB/components/HubStats/utils";
import { useSelector } from "react-redux";
import { getHubStats } from "apps/BWW_PLAY_HUB/modules/selectors/hub_stats";
import { max, forEach, get, orderBy, size } from "lodash";


const legend_items = [
	{
		type: EnumStatsType.pp,
	},
];

export const UserMonthlyHighestPoints: React.FC = () => {
	const { pp } = useSelector(getHubStats);

	const user_monthly_highest_points = pp.user_monthly_highest_points;

	if (!size(user_monthly_highest_points)) {
		return null;
	}

	const highest_points_keys: string[] = [];
	const highest_points_values: number[] = [];

	Object.entries(user_monthly_highest_points).forEach(([ key, value ]) => {
		highest_points_keys.push(key);
		highest_points_values.push(value);
	});

	const max_value = max(highest_points_values) || 0;

	const days_graph_values: TGraphItems = {};

	forEach(highest_points_keys, (item) => {
		const value = get(user_monthly_highest_points, item, 0);
		const percent = getPercent(value, max_value);

		const arr = [
			{
				type: EnumStatsType.pp,
				value,
				percent
			},
		];

		days_graph_values[item] = orderBy(arr, ['value'], ['asc']);
	});

	return (
		<HubStatsWrapper>
			<HubStatsTitle>Highest scoring contest per month</HubStatsTitle>
			<GraphWrapper>
				<GraphTitleValue>{ max_value }</GraphTitleValue>
				<HubStatsDaysGraph items={days_graph_values} format={'MMM'} />
			</GraphWrapper>
			<HubStatsLegend items={legend_items} show_value={false} show_percent={false} />
		</HubStatsWrapper>
	);
};
